import * as React from 'react';
import { StyleSheet, css, StyleDeclarationValue } from 'aphrodite';

const stylesheet = StyleSheet.create({
    default: {
        width: '30px',
        height: '30px',
        verticalAlign: 'middle',
    },
});

interface IconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    icon: string;
    styles?: StyleDeclarationValue[];
}

// TODO: change Icon to a separate SVG components when ready
export const Icon: React.SFC<IconProps> = (props) => {
    const { icon, styles, ...rest } = props;

    return (
        <img
            src={require((`../../Assets/images/${icon}.svg`))}
            className={css(stylesheet.default, ...(styles || []))}
            {...rest}
        />
    );
};
